import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Layout Components
import Layout from './components/layout/Layout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

// Page Components
import LandingPage from './pages/LandingPage';
import HomePageDetailed from './pages/HomePageDetailed';
import DashboardPage from './pages/DashboardPage';
import MintPage from './pages/MintPage';
import CollectionPage from './pages/CollectionPage';
import TimelinePage from './pages/TimelinePage';
import ProfilePage from './pages/ProfilePage';

// New Navigation Pages
import LearnPage from './pages/LearnPage';
import BuildPage from './pages/BuildPage';
import ExplorePage from './pages/ExplorePage';
import WalletPage from './pages/WalletPage';


// Context Providers
import { WalletProvider } from './contexts/WalletContext';
import { LegacyProvider } from './contexts/LegacyContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Styles
import './index.css';

function App() {
  return (
    <ErrorBoundary>
    <ThemeProvider>
      <WalletProvider>
        <LegacyProvider>
          <div className="min-h-screen">
            <Layout>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/home-detailed" element={<HomePageDetailed />} />
                
                              {/* New Navigation Routes */}
              <Route path="/learn" element={<LearnPage />} />
              <Route path="/build" element={<BuildPage />} />
              <Route path="/explore" element={<ExplorePage />} />
              <Route path="/wallet" element={<WalletPage />} />

                
                {/* Legacy Routes */}
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/mint" 
                  element={
                    <ProtectedRoute>
                      <MintPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/collection" 
                  element={
                    <ProtectedRoute>
                      <CollectionPage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/timeline" 
                  element={
                    <ProtectedRoute>
                      <TimelinePage />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/profile" 
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  } 
                />
              </Routes>
            </Layout>
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#fafafa',
                  color: '#1a1a1a',
                  border: '1px solid #e5e5e5',
                },
                success: {
                  iconTheme: {
                    primary: '#8B4513',
                    secondary: '#fafafa',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#8B4513',
                    secondary: '#fafafa',
                  },
                },
              }}
            />
          </div>
        </LegacyProvider>
      </WalletProvider>
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App; 